import getParams from './getParams';
import sendMessageToParent from './sendMessageToParent';

const updatePath = (router, filters, resetCoordinates, rectBounds, center) => {
    let parameters = getParams(filters, resetCoordinates, rectBounds, center);
    router.push({query: parameters});
    document.cookie = "keaze_widgets_search="+window.location.search;
    sendMessageToParent('urlChangedTo', window.location.href);
}

export default updatePath;
